import './vueBeforeInit.js'
import '../js/longtouch'
import '../js/v-filter'

import $x from './$x'
import Vue from 'vue'
import { initThemeColor } from './themeColorClient'
import '../router/permission'
import loadScripts from './utils/loadScripts';
import serverMap from '../../config/serverMap.js';
import kyEvent from './kyEvent';
import debugInfo from './debugInfo';
import nativeAdapter from './nativeAdapter/nativeAdapter';
import enUS from 'vant/es/locale/lang/en-US';
import zhTW from 'vant/es/locale/lang/zh-TW';
import { Locale } from 'vant';

Vue.use(debugInfo)

const QryEmpMan = 32768
export default function (noLangMsg) {
    return $x.post('login/getUserInfo').then(res => {
        var info = res || {}
        $x.userInfo.setUserInfo(info)
        $x.userInfo.save()
        if (info.wartermark) loadScripts($x.serverMap.domain + 'api/home/getWatermark')

        var promises = [initThemeColor()];
        //多语言js，加载完毕才能显示
        if (!noLangMsg) promises.push(new Promise(resolve => {
            loadScripts(serverMap.domain + 'Scripts/Msg.aspx?module=mobile&nocommon=1&lgid=' + info.lgid + '&_cv=' + info.cacheVer, resolve)
        }))
        addVantLocale(promises, info);
        //kyModule定制
        if (info.kyModule) promises.push(kyCustomize(info));
        if (info.isDebug && process.env.NODE_ENV === 'production') promises.push(addVConsole())
        if (nativeAdapter.isDingtalk) promises.push(hideDdTitle());
        if (nativeAdapter.isWechat) {
            $x('#app').elDo(el => el.classList.add('weixin'))
        }

        $x.userInfo.isQryAdmin = (info.adminType & QryEmpMan) > 0;
        return Promise.all(promises)
    })
}

function addVantLocale(promises, info) {
    if (info.lgid === 1028) {
        Locale.use('zh-TW', zhTW)
    } else if (info.lgid !== 2052 && info.lgid !== 0) { // 中文默认不需另加载。如果不是中文，其他都用英文, 初次登录未设置多语lgid为0
        Locale.use('en-US', enUS)
    }
}

async function hideDdTitle() {
    await nativeAdapter.ready().catch(e => console.log(e))
    if (nativeAdapter.hideTitle) {
        nativeAdapter.hideTitle()
        window.addEventListener('popstate', () => {
            nativeAdapter.hideTitle()
        })
    }
}

function addVConsole() {
    //分开打包，异步加载
    return import('vconsole').then(v => {
        var VConsole = v.default || v
        new VConsole()
    })
}

function kyCustomize(info) {
    document.body.insertAdjacentHTML('beforeend', '<link href="Custom/kymodel-h5.css?_cv=' + info.cacheVer + '" type="text/css" rel="stylesheet">');
    return new Promise(resolve => {
        loadScripts(serverMap.domain + 'Custom/kymodel-h5.js?_cv=' + info.cacheVer, function () {
            kyEvent.init()
            resolve()
        })
    })
}
